<template>
  <div class="flex flex-col w-7/12 mx-auto">
    <div class="flex flex-col mb-4">
      <div>
        <label class="font-semibold text-md text-grey-700">
          {{ $t('frontend_groovemail_leads_import_step_4_gdpr_regulations') }}
        </label>
      </div>
      <div>
        <label class="font-semibold text-sm text-grey-600">
          {{ $t('frontend_groovemail_leads_import_multiple_leads_gdpr_description_heading') }}
        </label>
      </div>
    </div>
    <div class="flex flex-col mt-2 bg-white rounded p-4 shadow">
      <div class="flex justify-between my-2">
        <p class="text-grey-700 text-sm">{{
          $t('frontend_groovemail_leads_import_multiple_leads_question_eu_leads_agreed_to_terms')
        }}</p>
        <div class="flex items-center">
          <span class="text-sm font-semibold mr-2">{{ $t('frontend_no') }}</span>
          <gd-toggle
            bgClass="bg-grey-300"
            v-model="localModel.euLeadsAgreedToTerms"
          />
          <span class="text-sm font-semibold ml-2">{{ $t('frontend_yes_I_am_sure') }}</span>
        </div>
      </div>
      <div class="flex justify-between my-2">
        <p class="text-grey-700 text-sm">{{
          $t('frontend_groovemail_leads_import_multiple_leads_question_eu_leads_agreed_to_communicate')
        }}</p>
        <div class="flex items-center">
          <span class="text-sm font-semibold mr-2">{{ $t('frontend_no') }}</span>
          <gd-toggle
            bgClass="bg-grey-300"
            v-model="localModel.euLeadsAgreedToCommunicate"
          />
          <span class="text-sm font-semibold ml-2">{{ $t('frontend_yes_I_am_sure') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'step4',

  props: {
    model: {
      required: true,
    },
  },

  data() {
    return {
      localModel: this.model,
    };
  },

  methods: {
    validate() {
      const isValid = true;
      this.$emit('on-validate', isValid);
      return isValid;
    },
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },
};
</script>